export const BASE_URL = 'https://dummyjson.com/';

export const BASE_URL1 = 'https://lpa.softsolutionsdev.com/api/';
// export const BASE_URL1 = 'http://127.0.0.1:8000/api/';


// export const BASE_URL1 = 'http://192.168.1.18:1206/api/';


export const IMAGE_URL1 = 'https://lpa.softsolutionsdev.com/app/public/';
// export const IMAGE_URL1 = 'http://127.0.0.1:8000/app/public/';


// export const IMAGE_URL1 = 'http://192.168.1.18:1206/app/public/';

export const IMAGE_URL2 = 'https://lpa.softsolutionsdev.com/app/';

// export const IMAGE_URL2 = 'http://127.0.0.1:8000/app/';